<div class="modal-container">
    <app-alert [text]="textAlert" [type]="2" *ngIf="showErrorAlert" (closeAlertEvent)="onErrorAlertClosed()"
        [isForDialog]="true"></app-alert>
    <div class="modal-exit">
        <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
    </div>
    <div class="modal-info">
        <div class="modal-title">{{ 'change_name' | translate }}</div>
        <div class="modal-text">
            {{ 'identify_file_with_name' | translate }}<br />
        </div>
    </div>
    <div class="modal-buttons">
        <div class="input-container">
            <label class="input-label">{{ 'file_name' | translate }}</label>
            <div class="input-wrapper">
                <input class="link-input" type="text" placeholder="{{ 'file_name' | translate }}"
                    [(ngModel)]="newName" />
                <label class="input-extension">URL</label>
            </div>
        </div>
        <button type="button" class="confirm-button" (click)="rename()">
            {{ 'accept' | translate }}
        </button>
    </div>
</div>